module.exports = __webpack_public_path__ + "static/media/alert-icon.dc75c2dd.svg";